import React, { useState, useRef } from "react";
import { Box, Image, Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton } from "@chakra-ui/react";

const ZoomableImage = ({ 
  src, 
  alt, 
  maxW, 
  w, 
  borderRadius = "lg", 
  loading = "lazy", 
  fallbackSrc,
  py,
  zoomLevel = 2,
  ...rest 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showZoom, setShowZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
  const imageRef = useRef(null);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleMouseMove = (e) => {
    if (!imageRef.current) return;

    const rect = imageRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    setZoomPosition({ x, y });
  };

  const handleMouseEnter = () => setShowZoom(true);
  const handleMouseLeave = () => setShowZoom(false);

  return (
    <>
      <Box 
        position="relative" 
        display="inline-block" 
        overflow="hidden" 
        borderRadius={borderRadius}
        w={w}
        maxW={maxW}
      >
        <Image
          ref={imageRef}
          src={src}
          alt={alt}
          w="100%"
          borderRadius={borderRadius}
          loading={loading}
          fallbackSrc={fallbackSrc}
          py={py}
          cursor="zoom-in"
          onMouseMove={handleMouseMove}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleOpen}
          transition="opacity 0.3s ease"
          opacity={showZoom ? 0 : 1}
          {...rest}
        />

        {/* Zoomed View */}
        {showZoom && (
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            backgroundImage={`url(${src})`}
            backgroundPosition={`${zoomPosition.x}% ${zoomPosition.y}%`}
            backgroundSize={`${zoomLevel * 70}%`}
            backgroundRepeat="no-repeat"
            pointerEvents="none"
            borderRadius={borderRadius}
            zIndex={1}
            boxShadow="0 4px 20px rgba(0, 0, 0, 0.15)"
          />
        )}
      </Box>

      <Modal isOpen={isOpen} onClose={handleClose} size="full" isCentered>
        <ModalOverlay bg="blackAlpha.800" />
        <ModalContent bg="transparent" boxShadow="none">
          <ModalCloseButton
            color="white"
            bg="blackAlpha.600"
            _hover={{ bg: "blackAlpha.700" }}
            size="lg"
            zIndex={2}
          />
          <ModalBody
            display="flex"
            alignItems="center"
            justifyContent="center"
            p={8}
            onClick={handleClose}
          >
            <Image
              src={src}
              alt={alt}
              maxH="90vh"
              maxW="90vw"
              objectFit="contain"
              cursor="zoom-out"
              fallbackSrc={fallbackSrc}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ZoomableImage;
